// Pure layout helpers for adding library components without drag-and-drop.
// Kept dependency-free so they are trivially unit-testable.

// Axis-aligned overlap test on the integer grid (half-open ranges, so an item
// ending at row N does not collide with one starting at row N).
function rectsCollide(a, b) {
  return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
}

// First free w x h cell scanning top -> bottom, then left -> right. When no gap
// fits within the occupied rows, returns a fresh row directly below everything.
// The requested width is clamped to the column count.
export function findFreeGridCell(layoutItems, w, h, cols) {
  const items = layoutItems || [];
  const width = Math.min(w, cols);
  const maxBottom = items.reduce((max, it) => Math.max(max, it.y + it.h), 0);
  for (let y = 0; y <= maxBottom; y++) {
    for (let x = 0; x <= cols - width; x++) {
      const candidate = { x, y, w: width, h };
      if (!items.some((it) => rectsCollide(candidate, it))) {
        return { x, y };
      }
    }
  }
  return { x: 0, y: maxBottom };
}

// Diagonal cascade so repeated taps do not perfectly stack. Wraps after `steps`.
export function cascadeOffset(addCount, stepPx = 28, steps = 6) {
  const i = ((addCount % steps) + steps) % steps;
  return { dx: i * stepPx, dy: i * stepPx };
}
